import colorPalette from "./colorPalette";

const {
  COLOR_LANDSCAPE,
  COLOR_BORDERS,
  COLOR_WATER,
  COLOR_LINE,
  COLOR_POINT_FILL,
  COLOR_SELECTED_POINT,
  COLOR_BLUE1,
  COLOR_BLUE2
} = colorPalette;

const COLORS = {
  BORDERS: COLOR_BORDERS,
  LANDSCAPE: COLOR_LANDSCAPE,
  LINE: COLOR_LINE,
  POINT: COLOR_SELECTED_POINT,
  POINT_FILL: COLOR_POINT_FILL,
  WATER: COLOR_WATER
};

const POINT_MARKER_ICON_TRAM = {
  path: "M7.98875878,3.01264637 L8.74318501,1.49882904 L11.9906323,1.49882904 L11.9906323,0 L1.99845433,0 L1.99845433,1.49882904 L6.74473068,1.49882904 L5.98533958,3.01264637 C2.85775176,3.10758782 0,3.73208431 0,6.49494145 L0,14.9283372 C0,16.3722248 1.18407494,17.5812646 2.58796253,17.9010304 L0.999203747,19.4847775 L0.999203747,19.9844028 L3.22744731,19.9844028 L5.22590164,17.9859485 L8.99297424,17.9859485 L10.9914286,19.9844028 L12.9898829,19.9844028 L12.9898829,19.4847775 L11.4910539,17.9859485 L11.4111007,17.9859485 C13.0997658,17.9859485 13.9890867,16.6120375 13.9890867,14.9283372 L13.9890867,6.49494145 C13.9890867,3.70210773 11.3811241,3.0975644 7.98875878,3.01264637 Z M6.99451991,16.4871194 C6.16515222,16.4871194 5.49569087,15.8176581 5.49569087,14.9882904 C5.49569087,14.1589227 6.16515222,13.4894614 6.99451991,13.4894614 C7.82388759,13.4894614 8.49334895,14.1589227 8.49334895,14.9882904 C8.49334895,15.8176581 7.82388759,16.4871194 6.99451991,16.4871194 Z M11.9906323,11.9906323 L1.99845433,11.9906323 L1.99845433,6.99451991 L11.9906323,6.99451991 L11.9906323,11.9906323 Z",
  strokeOpacity: 0,
  strokeWeight: 0,
  strokeColor: COLORS.POINT,
  fillColor: COLOR_BLUE1,
  fillOpacity: 1,
  scale: 1
};

const POINT_MARKER_ICON_BUS = {
  path: "M7.56651724,0 C3.38599507,0 0,0.472921182 0,3.78323645 L0,13.2413498 C0,14.0783941 0.368866995,14.8208719 0.94579803,15.3410542 L0.94579803,17.0246305 C0.94579803,17.5448128 1.37141379,17.9704286 1.89159606,17.9704286 L2.83743842,17.9704286 C3.36236453,17.9704286 3.78323645,17.5448128 3.78323645,17.0246305 L3.78323645,16.0788325 L11.3497537,16.0788325 L11.3497537,17.0246305 C11.3497537,17.5448128 11.7706256,17.9704286 12.2955517,17.9704286 L13.2413498,17.9704286 C13.761532,17.9704286 14.1871478,17.5448128 14.1871478,17.0246305 L14.1871478,15.3410985 C14.7640788,14.8209163 15.1329458,14.0784384 15.1329458,13.2413941 L15.1329458,3.78323645 C15.1329458,0.472921182 11.7469951,0 7.56651724,0 Z M3.31035961,14.1871921 C2.5253202,14.1871921 1.89164039,13.5535123 1.89164039,12.7684729 C1.89164039,11.9834335 2.5253202,11.3497537 3.31035961,11.3497537 C4.09539901,11.3497537 4.72907882,11.9834335 4.72907882,12.7684729 C4.72907882,13.5535123 4.09535468,14.1871921 3.31035961,14.1871921 Z M11.8226749,14.1871921 C11.0376355,14.1871921 10.4039557,13.5535123 10.4039557,12.7684729 C10.4039557,11.9834335 11.0376355,11.3497537 11.8226749,11.3497537 C12.6077143,11.3497537 13.2413941,11.9834335 13.2413941,12.7684729 C13.2413941,13.5535123 12.60767,14.1871921 11.8226749,14.1871921 Z M13.2413941,8.51231527 L1.89164039,8.51231527 L1.89164039,3.78323645 L13.2413941,3.78323645 L13.2413941,8.51231527 Z",
  strokeOpacity: 0,
  strokeWeight: 0,
  strokeColor: COLORS.POINT,
  fillColor: COLOR_BLUE2,
  fillOpacity: 1,
  scale: 1
};

const LINE_SYMBOL_CONFIG = {
  path: "M 0,-2 0,2",
  strokeOpacity: 1,
  strokeWeight: 2,
  scale: 1
};

const LINE_PATH_CONFIG = {
  clickable: false,
  geodesic: false,
  strokeOpacity: 0,
  strokeColor: COLORS.LINE,
  icons: [
    {
      icon: LINE_SYMBOL_CONFIG,
      repeat: "10px"
    }
  ]
};

const mapSettings = {
  clickableIcons: false,
  streetViewControl: false,
  panControlOptions: false,
  gestureHandling: "cooperative",
  backgroundColor: "rgb(255,255,255)",
  mapTypeControl: false,
  zoomControlOptions: {
    style: "SMALL"
  },
  zoom: 12,
  minZoom: 12,
  maxZoom: 17/*,
  styles: [
    {
      featureType: "landscape",
      stylers: [
        { hue: COLORS.LANDSCAPE },
        { saturation: 50.2 },
        { lightness: -34.8 },
        { gamma: 1 }
      ]
    },
    {
      featureType: "poi",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "road.highway",
      stylers: [
        { hue: COLORS.LANDSCAPE },
        { saturation: -19.8 },
        { lightness: -1.8 },
        { gamma: 1 }
      ]
    },
    {
      featureType: "road.arterial",
      stylers: [
        { hue: COLORS.LANDSCAPE },
        { saturation: 72.4 },
        { lightness: -32.6 },
        { gamma: 1 }
      ]
    },
    {
      featureType: "road.local",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "transit",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "administrative.province",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "administrative.locality",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "administrative.province",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "administrative.land_parcel",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "administrative.neighborhood",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "administrative.country",
      elementType: "geometry.stroke",
      stylers: [{ visibility: "on" }, { color: COLORS.BORDERS }]
    },
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [{ visibility: "off" }]
    },
    {
      featureType: "water",
      stylers: [
        { hue: COLORS.WATER },
        { saturation: -63.2 },
        { lightness: 38 },
        { gamma: 1 }
      ]
    }
  ]*/
};

export { mapSettings, LINE_PATH_CONFIG, POINT_MARKER_ICON_TRAM, POINT_MARKER_ICON_BUS };



// WEBPACK FOOTER //
// ./constants/mapSettings.js